import {z} from "zod/v4-mini"

export type MappingVectorType = "POINT" | "VECTOR" | "NORMAL" | "TEXTURE"
export const mappingVectorTypeSchema = z.enum(["POINT", "VECTOR", "NORMAL", "TEXTURE"])
